import apiClient from './api';

export default {
  getLegalDocs(type) {
    return apiClient.get('/legal-docs/', { params: { type } });
  },
  getLegalDoc(id) {
    return apiClient.get(`/legal-docs/${id}/`);
  }
};